import ls from 'localstorage-slim';

const AUTH_TOKEN = () => ls.get("token", {decrypt: true});
console.log("AUTH_TOKEN",AUTH_TOKEN)
const ROLE = () =>  ls.get("userRole", {decrypt: true});
console.log(ROLE,"userRole")

export {AUTH_TOKEN,ROLE};
